import { ReactSVG } from 'react-svg';
import {
    ContentWrapper,
    TopLogoWrapper,
    MobileLoginWrapper,
    BottomLogoWrapper,
} from './MobileLoginLayout.styles';

interface Props {
    children: React.ReactNode;
}

const MobileLoginLayout = ({ children }: Props) => {
    return (
        <MobileLoginWrapper>
            <TopLogoWrapper>
                <ReactSVG src={'/assets/fullTextLogo.svg'} />
            </TopLogoWrapper>
            <ContentWrapper>{children}</ContentWrapper>
            <BottomLogoWrapper>
                <ReactSVG src={'/assets/iconColor.svg'} />
            </BottomLogoWrapper>
        </MobileLoginWrapper>
    );
};

export default MobileLoginLayout;
